import { createReducer, on } from '@ngrx/store';
import { ValueType } from '@ra-web-tech-ui-toolkit/components';
import { format } from 'date-fns';
import { ToggleDateFilter } from 'src/app/core/models/alarm.model';
import { Shift } from 'src/app/core/models/configuration.model';
import { AlarmKPIPageActions } from '../../actions/alarm-kpi-page.actions';

export const alarmFeatureKey = 'alarmOverviewPage';

export interface AlarmKPIPageState {
  dateFilter: string;
  toggleDateFilter: ToggleDateFilter | undefined;
  areaFilter: ValueType | undefined;
  groupFilter: ValueType | undefined;
  shiftFilter: Shift | null;
  topBadActorsView: {
    value: number;
    index: number;
  };
}

export const initialState: AlarmKPIPageState = {
  dateFilter: format(new Date(), 'MMM / dd / yyyy'),
  toggleDateFilter: ToggleDateFilter.MONTH,
  areaFilter: 'all',
  groupFilter: 'all',
  shiftFilter: null,
  topBadActorsView: {
    value: 10,
    index: 1,
  },
};

export const reducer = createReducer(
  initialState,
  on(AlarmKPIPageActions.updateToggleDateFilter, (state, action) => {
    return {
      ...state,
      toggleDateFilter: action.toggleDateFilter,
    };
  }),
  on(AlarmKPIPageActions.setDateFilter, (state, action) => {
    return {
      ...state,
      dateFilter: action.dateFilter,
    };
  }),
  on(AlarmKPIPageActions.setAreaFilter, (state, action) => {
    return {
      ...state,
      areaFilter: action.areaFilter,
    };
  }),
  on(AlarmKPIPageActions.setGroupFilter, (state, action) => {
    return {
      ...state,
      groupFilter: action.groupFilter,
    };
  }),
  on(AlarmKPIPageActions.setShiftFilter, (state, action) => {
    return {
      ...state,
      shiftFilter: action.shiftFilter,
    };
  }),
  on(AlarmKPIPageActions.setTopBadActorsView, (state, action) => {
    const { value, index } = action;
    return {
      ...state,
      topBadActorsView: { index, value },
    };
  })
);
